import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { provideTranslations as provideCoreTranslations } from "@husbanken/designsystem-angular-core";
import { provideTranslations as provideHeaderTranslations } from "@husbanken/designsystem-angular-header-v2";
import { Provider } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function provideHbI18n(): Provider {
  return [
    provideCoreTranslations(),
    provideHeaderTranslations(),
    provideTranslateService({
      defaultLanguage: "nb",
      extend: true,
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
      },
    }),
  ];
}
